// // src/components/LocationSection.jsx
// import React from 'react';
// import { motion } from 'framer-motion';
// import { useInView } from 'react-intersection-observer';
// import { 
//   FaMapMarkerAlt, 
//   FaMosque, 
//   FaMountain, 
//   FaShoppingBag, 
//   FaUtensils, 
//   FaHospital,
//   FaSchool,
//   FaTaxi,
//   FaArrowRight
// } from 'react-icons/fa';
// import { Link } from 'react-router-dom';

// const LocationSection = () => {
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.1,
//   });

//   // Nearby places data
//   const nearbyPlaces = [
//     {
//       icon: <FaMosque />,
//       name: "Faisal Mosque",
//       distance: "2 min drive",
//       description: "Iconic landmark of Islamabad"
//     },
//     {
//       icon: <FaMountain />,
//       name: "Margalla Hills",
//       distance: "10 min drive",
//       description: "Hiking trails & scenic views"
//     },
//     {
//       icon: <FaShoppingBag />,
//       name: "Centaurus Mall",
//       distance: "Inside building",
//       description: "100+ brands & 50+ restaurants"
//     },
//     {
//       icon: <FaUtensils />,
//       name: "Mövenpick Hotel",
//       distance: "2 min walk",
//       description: "Fine dining & international cuisine"
//     },
//     {
//       icon: <FaHospital />,
//       name: "Shifa International",
//       distance: "12 min drive",
//       description: "Leading healthcare facility"
//     },
//     {
//       icon: <FaSchool />,
//       name: "LUMS University",
//       distance: "20 min drive",
//       description: "Top business school"
//     },
//     {
//       icon: <FaTaxi />,
//       name: "Metro Station",
//       distance: "5 min walk",
//       description: "Connect to entire city"
//     }
//   ];

//   // Map coordinates (Centaurus, Islamabad)
//   const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3320.123456789!2d73.087654!3d33.693456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38dfbfc123456789%3A0x123456789abcdef!2sCentaurus%20Mall!5e0!3m2!1sen!2s!4v1234567890123";

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.1,
//         delayChildren: 0.2,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { y: 20, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: { duration: 0.5, ease: "easeOut" }
//     },
//   };

//   return (
//     <section className="py-12">
//       <div className="container-custom">
//         {/* Section Header */}
//         <motion.div
//           initial={{ opacity: 0, y: 20 }}
//           animate={inView ? { opacity: 1, y: 0 } : {}}
//           transition={{ duration: 0.6 }}
//           className="text-center mb-8 space-y-2"
//         >
//           <div className="flex items-center justify-center gap-3">
//             <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//             <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
//               PRIME LOCATION
//             </span>
//             <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//           </div>
          
//           <h2 className="text-4xl md:text-5xl font-light text-[#1a2b3c] !mb-4">
//             Location &{' '}
//             <span className="font-bold text-[#c9a86c]">Neighborhood</span>
//           </h2>
          
//           <p className="md:text-[17px] 2xl:text-lg text-gray-500">
//             Situated in the heart of Islamabad, everything you need is just steps away
//           </p>
//         </motion.div>

//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
//           {/* Left Side - Map */}
//           <motion.div
//             ref={ref}
//             variants={itemVariants}
//             initial="hidden"
//             animate={inView ? "visible" : "hidden"}
//             className="relative"
//           >
//             <div className="rounded-2xl overflow-hidden shadow-2xl border border-gray-200 h-[450px]">
//               <iframe
//                 src={mapUrl}
//                 width="100%"
//                 height="100%"
//                 style={{ border: 0 }}
//                 allowFullScreen=""
//                 loading="lazy"
//                 referrerPolicy="no-referrer-when-downgrade"
//                 title="Centaurus Islamabad Location"
//                 className="w-full h-full"
//               ></iframe>
//             </div>

//             {/* Location Badge */}
//             <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-xl shadow-xl">
//               <div className="flex items-center gap-3">
//                 <FaMapMarkerAlt className="text-[#c9a86c] text-2xl" />
//                 <div>
//                   <p className="font-semibold text-[#1a2b3c]">Centaurus Complex</p>
//                   <p className="text-xs text-gray-500">Jinnah Avenue, Islamabad</p>
//                 </div>
//               </div>
//             </div>
//           </motion.div>

//           {/* Right Side - Nearby Places */}
//           <motion.div
//             variants={containerVariants}
//             initial="hidden"
//             animate={inView ? "visible" : "hidden"}
//             className="space-y-6"
//           >
//             <div>
//               <h3 className="text-2xl font-semibold text-[#1a2b3c] mb-2 flex items-center gap-2">
//                 <span className="w-1 h-6 bg-[#c9a86c] rounded-full"></span>
//                 What's Nearby
//               </h3>
//               <p className="text-gray-500">
//                 Everything you need is within minutes from your doorstep
//               </p>
//             </div>

//             {/* Places Grid */}
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               {nearbyPlaces.map((place, index) => (
//                 <motion.div
//                   key={index}
//                   variants={itemVariants}
//                   className="flex items-start gap-3 p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 group"
//                 >
//                   <div className="w-10 h-10 bg-[#c9a86c]/10 rounded-full flex items-center justify-center text-[#c9a86c] flex-shrink-0">
//                     {place.icon}
//                   </div>
//                   <div>
//                     <h4 className="font-medium text-[#1a2b3c]">{place.name}</h4>
//                     <p className="text-xs text-[#c9a86c] font-semibold mt-1">{place.distance}</p>
//                     <p className="text-xs text-gray-500 mt-1">{place.description}</p>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>

          
            

//             {/* Direction Button */}
//             <Link
//               to="https://maps.google.com/?q=Centaurus+Islamabad"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="inline-flex items-center gap-2 text-[#c9a86c] hover:text-[#b38f5a] transition font-medium mt-2 group"
//             >
//               <span>Get Directions</span>
//               <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
//             </Link>
//           </motion.div>
//         </div>

      
//       </div>
//     </section>
//   );
// };

// export default LocationSection;


// src/components/LocationSection.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { 
  FaMapMarkerAlt, 
  FaMosque, 
  FaMountain, 
  FaShoppingBag, 
  FaUtensils, 
  FaHospital,
  FaSchool,
  FaTaxi,
  FaArrowRight
} from 'react-icons/fa';
import { Link } from 'react-router-dom';

const LocationSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Nearby places data with enhanced details
  const nearbyPlaces = [
    {
      icon: <FaMosque />,
      name: "Faisal Mosque",
      distance: "2 min drive",
      description: "Iconic landmark of Islamabad",
      category: "Landmark"
    },
    {
      icon: <FaMountain />,
      name: "Margalla Hills",
      distance: "10 min drive",
      description: "Hiking trails & scenic views",
      category: "Nature"
    },
    {
      icon: <FaShoppingBag />,
      name: "Centaurus Mall",
      distance: "Inside building",
      description: "100+ brands & 50+ restaurants",
      category: "Shopping"
    },
    {
      icon: <FaUtensils />,
      name: "Mövenpick Hotel",
      distance: "2 min walk",
      description: "Fine dining & international cuisine",
      category: "Dining"
    },
    {
      icon: <FaHospital />,
      name: "Shifa International",
      distance: "12 min drive",
      description: "Leading healthcare facility",
      category: "Healthcare"
    },
    {
      icon: <FaSchool />,
      name: "LUMS University",
      distance: "20 min drive",
      description: "Top business school",
      category: "Education"
    },
    {
      icon: <FaTaxi />,
      name: "Metro Station",
      distance: "5 min walk",
      description: "Connect to entire city",
      category: "Transport"
    }
  ];

  // Map coordinates (Centaurus, Islamabad)
  const mapUrl = "https://www.google.com/maps?q=Centaurus+Mall+Islamabad&output=embed";

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.5, ease: "easeOut" }
    },
  };

  return (
    <>
      {/* SEO Meta Tags for Location */}
      <Helmet>
        <title>Prime Location | Centaurus Islamabad | StayIN Serviced Apartments</title>
        <meta name="description" content="Stay at Centaurus Islamabad - prime location with 2 min drive to Faisal Mosque, inside Centaurus Mall, near Margalla Hills. Perfect for business & leisure travelers. Book your stay today." />
        <meta name="keywords" content="Centaurus Islamabad location, Centaurus Mall Islamabad, Faisal Mosque nearby, Margalla Hills view, serviced apartments Islamabad prime location, StayIN location" />
      </Helmet>

      {/* Local Business Schema with Location Details */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Hotel",
          "name": "StayIN Centaurus Serviced Apartments",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Centaurus Complex, Jinnah Avenue, Blue Area",
            "addressLocality": "Islamabad",
            "addressCountry": "PK"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "33.7330",
            "longitude": "73.0715"
          },
          "amenityFeature": nearbyPlaces.map(place => ({
            "@type": "LocationFeatureSpecification",
            "name": place.name,
            "description": `${place.distance} - ${place.description}`
          }))
        })}
      </script>

      {/* Place Schema for Nearby Landmarks */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Place",
          "name": "StayIN Centaurus",
          "address": "Centaurus Complex, Islamabad",
          "touristAttraction": nearbyPlaces.map(place => ({
            "@type": "TouristAttraction",
            "name": place.name,
            "description": `${place.distance} from StayIN - ${place.description}`,
            "address": {
              "@type": "PostalAddress",
              "addressLocality": "Islamabad",
              "addressCountry": "PK"
            }
          }))
        })}
      </script>

      <section className="py-12" aria-label="Prime location of StayIN Centaurus in Islamabad">
        <div className="container-custom">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-center mb-8 space-y-2"
          >
            <div className="flex items-center justify-center gap-3">
              <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
              <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
                PRIME LOCATION
              </span>
              <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-light text-[#1a2b3c] !mb-4">
              Location &{' '}
              <span className="font-bold text-[#c9a86c]">Neighborhood</span>
            </h2>
            
            <p className="md:text-[17px] 2xl:text-lg text-gray-500">
              Situated in the heart of Islamabad, everything you need is just steps away
            </p>
          </motion.div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            {/* Left Side - Map */}
            <motion.div
              ref={ref}
              variants={itemVariants}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              className="relative"
            >
              <div className="rounded-2xl overflow-hidden shadow-2xl border border-gray-200 h-[450px]">
                <iframe
                  src={mapUrl}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Maps showing Centaurus Complex location in Islamabad, Pakistan - Prime location near Faisal Mosque and Margalla Hills"
                  className="w-full h-full"
                ></iframe>
              </div>

              {/* Location Badge */}
              <div className="absolute -bottom-4 -right-4 bg-white p-4 rounded-xl shadow-xl">
                <div className="flex items-center gap-3">
                  <FaMapMarkerAlt className="text-[#c9a86c] text-2xl" aria-hidden="true" />
                  <div>
                    <p className="font-semibold text-[#1a2b3c]">Centaurus Complex</p>
                    <p className="text-xs text-gray-500">Jinnah Avenue, Islamabad</p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Right Side - Nearby Places */}
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              className="space-y-6"
            >
              <div>
                <h3 className="text-2xl font-semibold text-[#1a2b3c] mb-2 flex items-center gap-2">
                  <span className="w-1 h-6 bg-[#c9a86c] rounded-full" aria-hidden="true"></span>
                  What's Nearby
                </h3>
                <p className="text-gray-500">
                  Everything you need is within minutes from your doorstep
                </p>
              </div>

              {/* Places Grid */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {nearbyPlaces.map((place, index) => (
                  <motion.div
                    key={index}
                    variants={itemVariants}
                    className="flex items-start gap-3 p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 group"
                  >
                    <div className="w-10 h-10 bg-[#c9a86c]/10 rounded-full flex items-center justify-center text-[#c9a86c] flex-shrink-0">
                      {place.icon}
                    </div>
                    <div>
                      <h4 className="font-medium text-[#1a2b3c]">{place.name}</h4>
                      <p className="text-xs text-[#c9a86c] font-semibold mt-1">{place.distance}</p>
                      <p className="text-xs text-gray-500 mt-1">{place.description}</p>
                    </div>
                  </motion.div>
                ))}
              </div>

              {/* Direction Button */}
              <Link
                to="https://maps.google.com/?q=Centaurus+Islamabad"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[#c9a86c] hover:text-[#b38f5a] transition font-medium mt-2 group"
                aria-label="Get directions to Centaurus Complex Islamabad on Google Maps"
              >
                <span>Get Directions</span>
                <FaArrowRight className="group-hover:translate-x-1 transition-transform" aria-hidden="true" />
              </Link>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LocationSection;